import React, { useEffect, useState } from "react";
import { loginUser } from "../auth/service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { doLogin } from "../auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../images/tmplLogo.png";
import "./Spinner.css";
import axios from "../api/baseurl";
import Footer from "./footer";
import backgroundImage from '../images/tmpl_bc_image.jpg';
import SecretKeyDecryption from "./secretKeyDecryption";


function Signin() {
  const navigate = useNavigate();
  const { fetchSecretKey } = SecretKeyDecryption();
  const [logindata, setLogindata] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const [secretKey, setSecretKey] = useState(null);
  const [versionResponse, setVersionResponse] = useState(null);

  // 15 min interval
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/version');
        console.log(response.data)
        const result = await response.json();
        setVersionResponse(result.version);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();  
  }, []);


  const handleChange = (event, field) => {
    setLogindata({ ...logindata, [field]: event.target.value });
  };

  const bufferToBase64 = (buffer) => {
    return window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
  };

  const encryptPassword = async (password, decryptedSecretKey) => {
    if (!decryptedSecretKey) throw new Error("Decrypted Secret key not available");
  
    // Ensure the key is either 128 bits (16 bytes), 192 bits (24 bytes), or 256 bits (32 bytes)
    let keyString = decryptedSecretKey;
    
    if (keyString.length !== 16 && keyString.length !== 24 && keyString.length !== 32) {
      // Pad or slice the key to ensure a valid AES key size
      keyString = keyString.padEnd(32, '0').slice(0, 32); // Ensure 256-bit key (32 bytes)
    }
  
    const encoder = new TextEncoder();
    const keyData = encoder.encode(keyString); // Convert the key string to Uint8Array
  
    // Import the key for AES-CBC encryption
    const key = await window.crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-CBC" },
      false, 
      ["encrypt"]
    );
  
    // Convert the password to be encrypted to a Uint8Array
    const data = encoder.encode(password);
  
    // Generate a random Initialization Vector (IV) for AES-CBC (16 bytes)
    const iv = window.crypto.getRandomValues(new Uint8Array(16));
  
    // Encrypt the password using AES-CBC
    const encryptedBuffer = await window.crypto.subtle.encrypt(
      { name: "AES-CBC", iv },
      key,
      data
    );
  
    // Helper function to convert ArrayBuffer to Base64
    const bufferToBase64 = (buffer) => {
      return window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
    };
  
    // Return the IV and encrypted password, separated by a colon
    return `${bufferToBase64(iv)}:${bufferToBase64(encryptedBuffer)}`;
  };
  
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const decryptedSecretKey = await fetchSecretKey(); // Fetch the secret key
      setSecretKey(decryptedSecretKey); // Set the secret key
      const encryptedPassword = await encryptPassword(logindata.password, decryptedSecretKey);

      const encryptedLoginData = {
        ...logindata,
        password: encryptedPassword,
      };

      loginUser(encryptedLoginData)

      .then((data) => {
        const userRole = data.role;
  
        if (userRole === "ROLE_SUPER" || userRole ==="ROLE_ADMIN") {
          localStorage.setItem("token", data.token);
          doLogin(data, () => {
            navigate("/users/dashboard");
          });
          toast.success("Login success");
        } else {
          toast.error("You do not have the required permissions to log in");
          setLoading(false);
        }
      })
        .catch((error) => {
          console.log(error);
          if (error.response.status === 401) {
            toast.error( "Incorrect Email Or Password") ;
          } else if (error.response.status === 404) {
            const logindetails = {
              username: logindata.username,
            };
            localStorage.setItem(
              "RegistrationData",
              JSON.stringify(logindetails)
            );
            toast.error(error.response.data.message);
        
          } else if (error.response.status === 400) {
            if (error.response.data && error.response.data.codes) {
                toast.error(error.response.data.defaultMessage); 
            }
          } else {
            toast.error("Something went wrong on the server!!");
          }
          setLoading(false);
        });
      } catch (error) {
        console.error("Error during login:", error);
        toast.error("Login failed");
        setLoading(false);
      }
    };

  return (
    <div class="bg-primary">
      {loading && <div className="loading"></div>}
     
      <div id="layoutAuthentication">
        <div id="layoutAuthentication_content">
          <main>
            <div className="container">
              <div className="row justify-content-center">
                <div
                  className="col-xxl-10 col-xl-10 col-lg-12"
                  style={{ height: "650px" }}
                >
                  <div className="card card-raised shadow-10 mt-5 mt-xl-10 mb-4">
                    <div className="row g-0">
                      <div
                        className="col- col-md-6 d-none d-md-block"
                        style={{
                          backgroundImage:
                          `url(${backgroundImage})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                      ></div>

                      <div className="col-lg-5 col-md-6">
                        <div className="card-body p-5">
                          <div className="text-center">
                            <img
                              class="mb-3"
                              src={logo}
                              alt="..."
                              style={{ height: "48px" }}
                            />

                            <h1 className="display-5 mb-0">TMPL</h1>
                            <div className="subheading-1 mb-5">Super Login</div>
                          </div>

                          <form onSubmit={handleFormSubmit}>
                            <div className="form-floating">
                              <input
                                className="form-control"
                                id="username"
                                type="email"
                                placeholder="name@example.com"
                                value={logindata.username}
                                onChange={(e) => handleChange(e, "username")}
                                Outlined
                                required
                              />
                              <label for="email">E-mail</label>
                            </div>
                            <br />

                            <div className="form-floating">
                              <input
                                className="form-control"
                                id="password"
                                type="password"
                                placeholder="Password"
                                value={logindata.password}
                                onChange={(e) => handleChange(e, "password")}
                                required
                              />
                              <label for="password">Password</label>
                            </div>

                           
                            <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                              <Link
                                className="small fw-500 text-decoration-none"
                                to="/forgotpassword"
                                style={{ color: "darkblue" }}
                              >
                                Forgot Password?
                              </Link>
                              <input
                                type="submit"
                                disabled={loading}
                                value="Login"
                                className="btn btn-primary"
                              />{" "}
                              {/* <Link
                                className="small fw-500 text-decoration-none"
                                onClick={handleTest}
                                style={{ color: "darkblue" }}
                              >
                              test
                              </Link> */}
                            </div>
                          </form>
                          <br />
                          <br />
                          <div className="container">
  <div className="row justify-content-center mb-2">
    <div className="col-auto text-center">
      <Link className="small fw-500 text-decoration-none" to="/labsignin">
        Lab Signin?
      </Link>
    </div>

    <div className="col-auto text-center">
      <Link className="small fw-500 text-decoration-none" to="/employersignin">
        Employer Signin?
      </Link>
    </div>
    </div>

  <div className="row justify-content-center mb-2">
  <div className="col-auto text-center">
      <Link className="small fw-500 text-decoration-none" to="/employeesignin">
        Employee Signin?
      </Link>
    </div>
  
    <div className="col-auto text-center">
      <Link className="small fw-500 text-decoration-none" to="/doctorsignin">
        Doctor Signin?
      </Link>
    </div>
  </div>
  <div className="row justify-content-center">
  <div className="col-auto text-center">
      <Link className="small fw-500 text-decoration-none" to="/labcorporatesignin">
        Lab Corporate Signin?
      </Link>
    </div>
  </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>

        <div id="layoutAuthentication_footer">
        <Footer/>
        </div>
      </div>
    </div>
  );
}
export default Signin;
